module.exports = __webpack_public_path__ + "img/gb13871-92-15x30x7.prt.3567984f.jpg";